/**
 * Cache busting utility
 * Appends version query parameter to asset URLs to prevent browser caching
 */

// Get version from environment variable, package.json, or use timestamp as fallback
// In production, set REACT_APP_VERSION environment variable during build
// Example: REACT_APP_VERSION=1.0.1 npm run build
let APP_VERSION = process.env.REACT_APP_VERSION;

// If no version set, try to get from package.json (requires import.meta or window)
if (!APP_VERSION) {
  // For Create React App, we can use a timestamp-based version
  // This ensures cache busting even without explicit version
  APP_VERSION = process.env.NODE_ENV === 'production' 
    ? process.env.REACT_APP_BUILD_TIME || Date.now().toString()
    : Date.now().toString();
}

/**
 * Adds cache-busting query parameter to an asset URL
 * @param {string} url - The asset URL to cache-bust
 * @returns {string} - The URL with version query parameter
 */
export const getCacheBustedUrl = (url) => {
  if (!url) return url;
  
  // If URL already has query parameters, append with &
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}v=${APP_VERSION}`;
};

/**
 * Gets the current app version
 * @returns {string} - The current app version
 */
export const getAppVersion = () => APP_VERSION;

